import {Injectable, inject} from '@angular/core';
import {Observable, of} from 'rxjs';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {catchError, map} from 'rxjs/operators';
import {ConsumerReport} from '../../../_data/reports/consumer/consumer-report';
import {ConsumerRequest} from '../../../_data/reports/consumer/consumer-request';
import {stringify} from 'flatted';
import {ApiEndpoints} from '../../../_constants/api-endpoints';

@Injectable({
  providedIn: 'root'
})
export class ConsumerReportsService {
  private http = inject(HttpClient);
  private apiEndpoints = inject(ApiEndpoints);


  // getReport(consumerRequest: ConsumerRequest): Observable<HttpResponse<ConsumerReport>> {
  //   return of(JSON.parse(this.mockResponse)).pipe(map(cr => new HttpResponse<ConsumerReport>({body: cr, status: 200})));
  // }

  getReport(consumerRequest: ConsumerRequest): Observable<HttpResponse<ConsumerReport>> {
    return this.http.post(this.apiEndpoints.consumerReport, consumerRequest, {observe: 'response'})
      .pipe(
        // tap((r: HttpResponse<any>) => console.debug(`Raw report response: ${JSON.stringify(r?.body)}`)),
        //API returns a special unicode character after end of json.  Remove it.
        map((r: HttpResponse<any>) => new HttpResponse<ConsumerReport>(
          {status: r.status, body: JSON.parse(r.body.jsonReport.replace(/\u0003/g, ''))}
        )),
        catchError(err => {
          console.error(`Error processing consumer report ${stringify(err)}`);
          return of(null);
        })
      );
  }

}
